import { EEsmStav } from 'services/spravaEmitenta/C4osoby';
import { Iosoba } from 'services/spravaEmitenta/zadostPravo';

import { EUdajeOFyzOsobach } from 'enums/amlz/udajeOFyzOsobach';
import { EAnoNe } from 'enums/anoNe';

export interface IAmlz {
    amlz: {
        c1?: Ic1;
        c2?: Ic2Prehled;
        c3neprima?: Ic3neprima;
        c3prima?: Ic3prima;
        c4?: Ic4;
        c5?: Ic5;
        c6?: Ic6;
    };
    goToC6?: boolean;
    goToC2Osoba?: number;
    datumzmeny?: string;
    idmb?: string;
    idzadosti?: number;
    stat?: string;
    redirect?: string;
    stav?: string;
    sprava?: string;
    idPoslednejHotovejZadosti?: number;
}

export interface ISubj {
    adma?: string;
    datumnar?: string;
    datumnarozeni?: string;
    identifikaceosoby?: string;
    idmb?: string;
    jestatutar?: boolean;
    jmeno?: string;
    kost?: string;
    mema?: string;
    misto?: string;
    obcanstvi?: ISubjObcanstvi[];
    osobasankceje?: boolean;
    podil?: string;
    popisref?: string;
    prijmeni?: string;
    prilozenesoubory?: ISubjPrilozenesoubory[];
    prilozenysoubor?: ISubjPrilozenysoubor;
    pscm?: string;
    stat?: string;
    statlegalizaceje?: boolean;
    stavref?: string;
    telefon?: string;
    tpma?: string;
    zastupuje?: string;
    zc2?: string;
    zemepuv?: string[];
    dotaznikpep?: ISubjDotaznik;
    stavesm?: EEsmStav;
    duvododebrani?: string;
    c2osobaoid?: number;
}

export interface ISubjDotaznik {
    funkce: string;
    puvodmajetku: string[];
    puvodmajetkujine: string;
    rozsahmajetku: string;
    zrizovatelmaj: boolean;
    majetkovepomery: boolean;
    prevzdrojmajetku: string;
    predpvysemajetku: string;
}

export enum EObcanstviDruhDokladu {
    OBCANKA = 'OBCANKA',
    PAS = 'PAS',
    RIDICAK = 'RIDICAK',
    JINE = 'JINE'
}

export interface ISubjObcanstvi {
    cisdokladu?: string;
    druhdokladu?: EObcanstviDruhDokladu;
    druhdokladujiny?: string;
    platnostdo?: string;
    stat?: string;
    vydal?: string;
}

export interface ISubjPrilozenysoubor {
    oblast?: string;
    tempnazev?: string;
    orignazev?: string;
    stavref?: string;
    popisref?: string;
    dn?: string;
    issuer?: string;
}

export interface ISubjPrilozenesoubory {
    oblast?: string;
    orignazev?: string;
    popisref?: string;
    stavref?: string;
    tempnazev?: string;
}

// //////  C1  /////////////////////
export interface Ic1 {
    adma?: string;
    idmb?: string;
    kodpravniformy?: string;
    kost?: string;
    lei?: string;
    mema?: string;
    nazev?: string;
    popisref?: string;
    pravniforma?: string;
    pscm?: string;
    stat?: string[] | string;
    stavref?: string;
    predcisli?: string;
    cislouctu?: string;
    banka?: string;
    iban?: string;
    madic?: string;
    dic?: string;
    email?: string;
    telefon?: string;
}
// ////////////////////////////////

// /////// C2 //////////////////////
export interface Ic2Prehled {
    count?: number;
    order?: string;
    limit?: number;
    offset?: number;
    vse?: boolean;
    osoby: Iosoba[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    subj?: any; // TODO: MHO - doplnit typ
}

// ///////////////////////////////

// /////////// C3 ////////////////////
export interface Ic3neprima {
    ma?: EAnoNe | '';
    subj?: ISubj[];
}

export interface Ic3prima {
    ma?: EAnoNe | '';
    subj?: ISubj[];
}
// ////////////////////////////////

// /////////// C4 /////////////////////
export interface Ic4 {
    duvod?: string;
    empro?: EUdajeOFyzOsobach;
    datumnacteni?: string;
    subj?: ISubj[];
    prilozenesoubory?: ISubjPrilozenesoubory[];
}
// ////////////////////////////////

// /////////// C5 /////////////////////
export interface Ic5 {
    ma?: EAnoNe;
    subj?: ISubj[];
}
// ////////////////////////////////

// /////////// C6 /////////////////////
export interface Ic6 {
    jmeno?: string;
    prijmeni?: string;
    email?: string;
    telefon?: string;
    jazyk?: string;
    identifikace?: string;
    prilozenysoubor?: {
        oblast?: string;
        tempnazev?: string;
        orignazev?: string;
        dn?: string;
        issuer?: string;
    };
}
// ////////////////////////////////
